import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import remarkGfm from 'remark-gfm';

const LINK_CLASSES = 'text-blue-600 underline hover:text-blue-800';

const isExternalUrl = (href: string | undefined) => href && (/^https?:\/\//.test(href) || href.startsWith('//'));

export const Markdown = ({ children }: { children: string }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ children: linkChildren, href, ...props }) => {
          if (!href) {
            return <span {...props}>{linkChildren}</span>;
          }
          if (isExternalUrl(String(href))) {
            return (
              <a {...props} href={String(href)} className={LINK_CLASSES} target='_blank' rel='noopener noreferrer'>
                {linkChildren}
              </a>
            );
          }
          return (
            <Link to={String(href)} className={LINK_CLASSES}>
              {linkChildren}
            </Link>
          );
        },
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
